import React, { FC } from 'react';
import { useStaticPermission } from 'common/auth/Authorize';
import { DataTableToolbar } from '@utmost.co/utmost-design-system';
import { IconButton } from '@beeline.com/bp-design-system';
import { useCustomFieldsAndObjectsIntl } from '../translations/useCustomFieldsAndObjectsIntl';
import { CustomFieldDefinitionQuery } from './utils/CustomFields.types';

interface Props {
  totalCount: number;
  pageDataCount: number;
  onCustomFieldAdd: () => void;
  variables: CustomFieldDefinitionQuery | undefined;
}

export const CustomFieldDefinitionsToolbar: FC<React.PropsWithChildren<Props>> = ({
  totalCount,
  pageDataCount,
  onCustomFieldAdd,
  variables
}) => {
  const intl = useCustomFieldsAndObjectsIntl();
  const { CREATE } = useStaticPermission('CUSTOM_FIELD_DEFINITION');

  return (
    <DataTableToolbar
      message={intl.totalCount({ totalCount, pageDataCount })}
      searchProps={{
        value: variables?.query?.search
      }}
      beforeActions={
        <IconButton
          tooltipText={intl.addCustomField}
          iconName="add"
          disabled={!CREATE}
          disabledToolTipText={intl.noPermissionForAction}
          dataTest="settings__add__custom-field__button"
          onClick={onCustomFieldAdd}
        />
      }
    />
  );
};
